import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import './MenuSiderSearch.scss'
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function MenuSider(props) {
    const { location, categories, setReloadCategories } = props;
    let history = useHistory();
    const [ btnCollapse, setBtnCollapse ] = useState(true);
    const [ btnHidden, setBtnHidden ] = useState(true);
    const [ reloadButton, setReloadButton ] = useState(false)

    useEffect(() => {
        let size = window.innerWidth;
        if(size >= 768){
            setBtnCollapse(true);
            setBtnHidden(true);
        }else{
            setBtnCollapse(false);
            setBtnHidden(false);
        }

        setReloadButton(false);
    }, [reloadButton]);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            
            let txt_busqueda = (e.target.value)
									.replace(/[ÁÀÄ]/g,"A")
									.replace(/[áàä]/g,"a")
									.replace(/[ÉÈË]/g,"E")
									.replace(/[éèë]/g,"e")
									.replace(/[ÍÌÏ]/g,"I")
									.replace(/[íìï]/g,"i")
									.replace(/[ÓÒÖ]/g,"O")
									.replace(/[óòö]/g,"o")
									.replace(/[ÚÙÜ]/g,"U")
									.replace(/[úùü]/g,"u")
									.replace(/[Ç]/g,"C")
									.replace(/[ç]/g,"c")
									.replace(/[Ñ]/g,"N")
									.replace(/[ñ]/g,"n")
									.replace(/[^a-zA-Z0-9 ]/g, '');
            let busqueda = txt_busqueda.trim().replace(/ /g, '-');
            e.target.value = txt_busqueda;
            let id_cat = 0;
            let id_sub = 0;

            history.push({
                pathname: '/search',
                search: `?data=${busqueda}&id_cat=${id_cat}&id_sub=${id_sub}`,
                state: [{ data: busqueda, id_cat: id_cat, id_sub: id_sub, prevPath : location.pathname }]
            });
        }
    }

    const handleClickCollapse = () => {
        let size = window.innerWidth;
        if(size < 768){
            setBtnCollapse(!btnCollapse);
        }
        if(size >= 768){
            setBtnCollapse(true);
        }
    }

    return (
        <>

            <nav className="col-12 col-md-2 d-md-block sidebar border-bottom border-right h-999999">
                <div className="sidebar-sticky">
                <ul className="nav flex-column mt-3">
                    <li className="nav-item">
                        <div className="row">
                            <div className="col-11">
                                <input 
                                    className="form-control form-control-dark w-100" 
                                    type="text" 
                                    placeholder="Search" 
                                    aria-label="Search"
                                    maxLength="1000"
                                    onKeyDown={handleKeyDown}
                                />
                            </div>
                            <div className="col-1 p-0 text-center">
                                <FontAwesomeIcon
                                    id="btnSandwich"
                                    role="button" 
                                    tabIndex="0" 
                                    icon={faBars} 
                                    className={btnHidden ? 'd-none' : 'd-block fa-2x'}
                                    style={{color: '#666666'}}
                                    onClick={handleClickCollapse}
                                />
                            </div>
                        </div>
                    </li>
                </ul>
                <ul 
                    className={ btnCollapse ? "nav flex-column mt-3 mb-2 collapse show" : "nav flex-column mt-3 mb-2 collapse" }
                >
                    
                    <Cat 
                        categories={categories} 
                        location={location} 
                        history={history} 
                        setReloadCategories={setReloadCategories}
                        setBtnCollapse={setBtnCollapse}
                        btnCollapse={btnCollapse}
                    />

                </ul>
                </div>
            </nav>
        </>
    )
}

function Cat (props) {
    const { categories, location, history, setReloadCategories, setBtnCollapse, btnCollapse } = props;

    return(
        <>
            {Array.from(categories).map((cat, index) => {
                return (
                    <li key={index} className="nav-item">
                        <Link 
                            to={""} 
                            className='nav-link link-sin-espacio font-weight-bold' 
                            style={{ pointerEvents: 'none', color: '#3285f6' }}
                            onClick={e => e.preventDefault()}
                        >
                        {cat.category && cat.category.nm_categoria}
                        </Link>

                        {Array.from(cat.subcategory).map((sub, indexSub) => {
                            return (
                                <Sub 
                                    key={indexSub} 
                                    sub={sub} 
                                    location={location} 
                                    history={history} 
                                    setReloadCategories={setReloadCategories} 
                                    setBtnCollapse={setBtnCollapse}
                                    btnCollapse={btnCollapse}
                                />
                            )
                        })}
                    </li>
                )
            })}
        </>
    )
}

function Sub (props) {
    const { sub, location, history, setReloadCategories, setBtnCollapse, btnCollapse } = props;

    const handleClick = (e) => {
        e.preventDefault();

        let busqueda = 0;
        let id_cat = 0;
        let id_sub = 0;

        if(sub._id){
            id_sub=sub._id;
        }

        history.push({
            pathname: '/search',
            search: `?data=${busqueda}&id_cat=${id_cat}&id_sub=${id_sub}`,
            state: [{ data: busqueda, id_cat: id_cat, id_sub: id_sub, prevPath : location.pathname }]
        });

        let size = window.innerWidth;
        if(size < 768){
            setBtnCollapse(!btnCollapse);
        }
        setReloadCategories(true);
    }

    return(
        <ul className="texto-submenu">
            <li>
                <Link 
                    to={''}
                    className={ location.search.substring(location.search.lastIndexOf("=") + 1).localeCompare(sub._id) === 0 ? "nav-link font-weight-bold link-sin-espacio" : "nav-link link-sin-espacio"}
                    onClick={handleClick}
                >
                    {sub && sub.nm_subcategoria}
                </Link>
            </li>
        </ul>
    )
}